import axios from "axios";

import { BlobContainer } from "../types";

export default function useMediaUpload() {
    return {
        mediaUpload: async (
            file: BlobContainer,
            url: string,
            onUpdateProgress: (progress: number) => void,
        ): Promise<void> => {
            await axios.put(url, file.blob, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            onUpdateProgress(100);
            return;
        },
    };
}
